import {
  GET_THUOC_TINH_TAI_SAN,
  GET_THUOC_TINH_TAI_SAN_SUCCESS,
  GET_THUOC_TINH_TAI_SAN_FAILURE,
  GET_THUOC_TINH_TAI_SAN1,
  GET_THUOC_TINH_TAI_SAN1_SUCCESS,
  GET_THUOC_TINH_TAI_SAN1_FAILURE,
} from "actions/ThuocTinhTaiSan/actionTypes";

const initialState = {
  getThuocTinhTaiSanLoading: false,
  objThuocTinhTaiSan: [],
  thuocTinhTaiSanLoaded: false,
  objThuocTinhTaiSan1: [],
};

const getThuocTinhTaiSan = (state, action) => ({
  ...state,
  getThuocTinhTaiSanLoading: true,
  thuocTinhTaiSanLoaded: true,
});

const getThuocTinhTaiSanSuccess = (state, action) => {
  return {
    ...state,
    getThuocTinhTaiSanLoading: false,
    thuocTinhTaiSanLoaded: true,
    objThuocTinhTaiSan: action.payload,
  };
};

const getThuocTinhTaiSanFailed = (state, action) => ({
  ...state,
  getThuocTinhTaiSanLoading: false,
  objThuocTinhTaiSan: [],
  thuocTinhTaiSanLoaded: true,
});
const getThuocTinhTaiSan1 = (state, action) => ({
  ...state,
  getThuocTinhTaiSan1Loading: true,
  thuocTinhTaiSan1Loaded: true,
});

const getThuocTinhTaiSan1Success = (state, action) => {
  return {
    ...state,
    getThuocTinhTaiSan1Loading: false,
    thuocTinhTaiSan1Loaded: true,
    objThuocTinhTaiSan1: action.payload,
  };
};

const getThuocTinhTaiSan1Failed = (state, action) => ({
  ...state,
  getThuocTinhTaiSan1Loading: false,
  objThuocTinhTaiSan1: [],
  thuocTinhTaiSan1Loaded: true,
});
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_THUOC_TINH_TAI_SAN:
      return getThuocTinhTaiSan(state, action);
    case GET_THUOC_TINH_TAI_SAN_SUCCESS:
      return getThuocTinhTaiSanSuccess(state, action);
    case GET_THUOC_TINH_TAI_SAN_FAILURE:
      return getThuocTinhTaiSanFailed(state, action);
    case GET_THUOC_TINH_TAI_SAN1:
      return getThuocTinhTaiSan1(state, action);
    case GET_THUOC_TINH_TAI_SAN1_SUCCESS:
      return getThuocTinhTaiSan1Success(state, action);
    case GET_THUOC_TINH_TAI_SAN1_FAILURE:
      return getThuocTinhTaiSan1Failed(state, action);
    default:
      return state;
  }
};

export default authReducer;
